import React, { Component } from 'react';
import { FORMAT_NUMBER, SERVICE_API, CURRENCY, BASE_URL } from '../libs/utils/Const';

class PriceWithTaxesModal extends Component {
  
    render() {
        const { newOrderModel } = this.props;
        return (
            <div className="modal fade" id="priceWithTaxesModal" data-keyboard="false" tabIndex="-1" aria-labelledby="priceWithTaxesModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">

                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"  /*onClick={ShowSearchModal}*/>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive scrollSearchs">
                                <table className="table">
                                    <thead className='sticky-headerPOS'>
                                        <tr>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="p-2 px-3 text-uppercase">Artículo</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Cantidad</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Precio U.</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">IVA %</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Precio con IVA</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newOrderModel && newOrderModel.Items &&
                                            newOrderModel.Items.map((item, index) => {
                                                return (
                                                    <tr
                                                        key={`SearchItemId${index}`}
                                                        // onClick={() => SelectItemSuggestion(index)}
                                                        // style={{ background: index === itemIndexSuggestion && '#FFF8D2' }}
                                                        >
                                                        <th scope="row" className="border-0" >
                                                            <div className="p-2">
                                                                <img src={item.PicturName ? (BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/noImage.png')} alt="" width="70" className="img-fluid rounded shadow-sm" />
                                                                <div className="ml-3 d-inline-block align-middle">
                                                                    <h5 className="mb-0">
                                                                        <a href="#" className="text-dark d-inline-block align-middle" data-dismiss="modal" data-toggle="modal" >{item.ItemCode}</a>
                                                                    </h5><span className="text-muted font-weight-normal font-italic d-block">{item.ItemName && item.ItemName.substring(0, 52)}</span>
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <td className="align-middle">
                                                            <strong>
                                                                <input
                                                                    type="number"
                                                                    defaultValue={1} min={1}
                                                                    className="text-center input-cantidad"
                                                                    value={item.Quantity}
                                                                    disabled={true}
                                                                    // onChange={(event) => { ChangeQuantitySuggestions(event.nativeEvent.target.value, index) }} 
                                                                    />
                                                            </strong>
                                                        </td>
                                                        <td className="align-middle"><strong>{`${CURRENCY} ${FORMAT_NUMBER.new(item.Price)}`}</strong></td>
                                                        <td className="align-middle"><strong>{(item.TaxeRate ?? 0.00)}</strong></td>
                                                        <td className="align-middle"><strong>{`${CURRENCY} ${FORMAT_NUMBER.new(Number(item.Total ?? 0.00) + Number(item.TaxeResult ?? 0.00))}`}</strong></td>

                                                    </tr>
                                                )
                                            })

                                        }
                                    
                                    </tbody>
                                </table>
                            </div>




                        </div>
                        <div className="modal-footer">

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PriceWithTaxesModal;